import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import ADMIN_API_URL from "../../../config/AdminApiUrl";

export const getEInvoiceConfig = createAsyncThunk(
  "eInvoiceConfiguration/get",
  async (tenantId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        ADMIN_API_URL.EINVOICE_CONFIGURATION.GET(tenantId)
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const saveEInvoiceConfig = createAsyncThunk(
  "eInvoiceConfiguration/save",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        ADMIN_API_URL.EINVOICE_CONFIGURATION.SAVE,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const testEInvoiceConnection = createAsyncThunk(
  "eInvoiceConfiguration/testConnection",
  async (tenantId, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        ADMIN_API_URL.EINVOICE_CONFIGURATION.TEST_CONNECTION(tenantId)
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const eInvoiceConfigurationSlice = createSlice({
  name: "eInvoiceConfiguration",
  initialState: {
    config: null,
    isLoading: false,
    isSaving: false,
    isTesting: false,
    testResult: null,
  },
  reducers: {
    clearTestResult(state) {
      state.testResult = null;
    },
    clearConfig(state) {
      state.config = null;
      state.testResult = null;
    },
  },
  extraReducers: (builder) => {
    // Get config
    builder.addCase(getEInvoiceConfig.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getEInvoiceConfig.fulfilled, (state, action) => {
      state.isLoading = false;
      state.config = action.payload;
    });
    builder.addCase(getEInvoiceConfig.rejected, (state) => {
      state.isLoading = false;
    });

    // Save config
    builder.addCase(saveEInvoiceConfig.pending, (state) => {
      state.isSaving = true;
    });
    builder.addCase(saveEInvoiceConfig.fulfilled, (state) => {
      state.isSaving = false;
    });
    builder.addCase(saveEInvoiceConfig.rejected, (state) => {
      state.isSaving = false;
    });

    // Test connection
    builder.addCase(testEInvoiceConnection.pending, (state) => {
      state.isTesting = true;
      state.testResult = null;
    });
    builder.addCase(testEInvoiceConnection.fulfilled, (state, action) => {
      state.isTesting = false;
      state.testResult = action.payload;
    });
    builder.addCase(testEInvoiceConnection.rejected, (state) => {
      state.isTesting = false;
      state.testResult = { success: false, message: "Connection test failed" };
    });
  },
});

export const { clearTestResult, clearConfig } =
  eInvoiceConfigurationSlice.actions;
export default eInvoiceConfigurationSlice.reducer;
